import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getLocalStorageItem } from '@/helpers/storage';
import { STORAGE_KEYS } from '@/constants/storageKeys';

interface ViewedStoriesStateIF {
    viewedStories: string[];
}

const initialState: ViewedStoriesStateIF = {
    viewedStories:
        getLocalStorageItem<string[]>(STORAGE_KEYS.ViewedStoriesKey) || [],
};

const viewedStoriesSlice = createSlice({
    name: 'viewedStories',
    initialState,
    reducers: {
        markStoryAsViewed: (state, action: PayloadAction<string>) => {
            if (!state.viewedStories.includes(action.payload)) {
                state.viewedStories.push(action.payload);
            }
        },
    },
});

export const { markStoryAsViewed } = viewedStoriesSlice.actions;

viewedStoriesSlice.reducerPath = 'viewedStories';

export const viewedStoriesReducer = viewedStoriesSlice.reducer;
export { viewedStoriesSlice };
